// @spec GHG-STR-064
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { ProtocolCompliancePage } from '@/features/ghg/components/ProtocolCompliancePage';
import { useGHGPagePeriod } from '@/features/ghg/hooks/use-ghg-page-period';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/ghg/protocol-compliance')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.ghgProtocolCompliance'),
  }),
  component: ProtocolComplianceRoute,
});

function ProtocolComplianceRoute() {
  const { periodId } = useGHGPagePeriod();

  return (
    <ProtocolCompliancePage
      initialReportingPeriodId={periodId}
    />
  );
}
